import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import CancelIcon from '@mui/icons-material/Close'
import { Box, Button, FormControlLabel, FormGroup, Switch, TextField } from '@mui/material'
import {
    GridToolbarContainer,
    type GridToolbarProps as GridToolbarPropsOriginal,
    type ToolbarPropsOverrides
} from '@mui/x-data-grid'
import { FaixaRatingRow } from '../../grupo.types'

declare module '@mui/x-data-grid' {
    interface ToolbarPropsOverrides {
        faixaRating: Partial<FaixaRatingRow>
        onFieldChange: (
            field: keyof FaixaRatingRow,
            evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
        ) => void
        onSave: () => void
        onClear: () => void
    }
}

type RatingFormDataGridToolbarProps = GridToolbarPropsOriginal & ToolbarPropsOverrides

export default function RatingFormDataGridToolbar(props: RatingFormDataGridToolbarProps) {
    const { faixaRating, onFieldChange, onSave, onClear } = props

    return (
        <GridToolbarContainer>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'baseline',
                    gap: '10px',
                    marginBottom: '20px'
                }}
            >
                <TextField
                    value={faixaRating.sigla}
                    onChange={(e) => onFieldChange('sigla', e)}
                    label="Sigla"
                    variant="standard"
                />
                <TextField
                    value={faixaRating.descricao}
                    onChange={(e) => onFieldChange('descricao', e)}
                    label="Descrição"
                    variant="standard"
                />
                <TextField
                    type="number"
                    value={faixaRating.faixaInicial}
                    onChange={(e) => onFieldChange('faixaInicial', e)}
                    label="Faixa Inicial"
                    variant="standard"
                />
                <TextField
                    type="number"
                    value={faixaRating.faixaFinal}
                    onChange={(e) => onFieldChange('faixaFinal', e)}
                    label="Faixa Final"
                    variant="standard"
                />
                <div>
                    <FormGroup>
                        <FormControlLabel
                            label="Mostrar Rating"
                            control={
                                <Switch
                                    checked={faixaRating.mostrarRating}
                                    onChange={(e) => onFieldChange('mostrarRating', e)}
                                />
                            }
                        />
                    </FormGroup>
                </div>
                <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={onSave}>
                    Salvar
                </Button>
                <Button color="secondary" variant="outlined" startIcon={<CancelIcon />} onClick={onClear}>
                    {faixaRating.id ? 'Cancelar' : 'Limpar'}
                </Button>
            </Box>
        </GridToolbarContainer>
    )
}
